const styleElement = document.createElement("dom-module");

styleElement.innerHTML = /*html*/`<template>
  <style>
    :host {
      display: block;
      width: 100%;
    }

    .limit-usage-banner {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      width: 100%;
      max-width: 666px;
      padding: 6px 12px;
      background: #ECECEC;
      border-top-left-radius: 13px;
      border-top-right-radius: 13px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      opacity: 1;
    }

    .limit-usage-banner__text {
      margin: 0;
      min-width: 0;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #7F7F7F;
    }

    .limit-usage-banner__text b {
      color: #333333;
    }

    .limit-usage-banner__cta-btn {
      box-sizing: border-box;
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 96px;
      height: 26px;
      padding: 4px 12px;
      border: 0;
      border-radius: 24px;
      background: #ffffff;
      box-shadow: 0px 1px 2.6px 0px #42424217;
      opacity: 1;
      font-family: "Lato", sans-serif;
      font-weight: 700;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0;
      color: #3570d2;
      cursor: pointer;
      white-space: nowrap;
    }

    .limit-usage-banner__cta-btn:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: 2px;
    }
  </style>
</template>`;

styleElement.register("limit-usage-banner-style");
